import { Routes } from '@angular/router';
import { CollectionContainerViewComponent } from '@tamilarasitech/tt-branding-app-lib';
import { TTUICollectionModule } from '@tamilarasitech/tt-branding-app-lib';
import { UnregisteredComponent } from './modules/authentication/pages/unregistered/unregistered.component';
import { UnauthorizedComponent } from './modules/authentication/pages/unauthorized/unauthorized.component';
import { authChildGuard, authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'signups',
    loadComponent: () =>
      import('./pages/signups-review/signups-review.component').then(
        (m) => m.SignupsReviewComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'collection/manage/schools/pending-approvals',
    loadComponent: () =>
      import('./pages/schools-pending-approvals/schools-pending-approvals.component').then(
        (m) => m.SchoolsPendingApprovalsComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'unregistered',
    component: UnregisteredComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@tamilarasitech/tt-branding-app-lib').then(
        (m) => m.TtAuthenticationModule
      ),
  },
  {
    path: 'collection/manage/:id',
    component: CollectionContainerViewComponent,
    canActivateChild: [authChildGuard],
    loadChildren: () => TTUICollectionModule,
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];

